import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { PortalProvider } from 'context';
import Authentication from 'components/Authentication';
import PortalLogin from 'features/Login';
import Dashboard from 'features/Dashboard';
import Schedule from 'features/Schedule';
import Success from 'features/Success';
import Redirect404 from 'features/Redirect404';
import sharedMessages from 'messages';
import './App.scss';

class App extends React.Component {
    render() {
        return (
            <div className="app-wrapper">
                <Helmet>
                    <title>{sharedMessages.viewlogiesAllCaps}</title>
                </Helmet>
                <PortalProvider>
                    <Router>
                        <Routes>
                            <Route path="/:organizationId/login" element={<PortalLogin />} />
                            <Route
                                exact
                                path="/:organizationId"
                                element={
                                    <Authentication>
                                        <Dashboard />
                                    </Authentication>
                                }
                            ></Route>
                            <Route
                                path="/:organizationId/schedule/success"
                                element={
                                    <Authentication>
                                        <Success />
                                    </Authentication>
                                }
                            ></Route>
                            <Route
                                path="/:organizationId/schedule"
                                element={
                                    <Authentication>
                                        <Schedule />
                                    </Authentication>
                                }
                            ></Route>
                            <Route path="/" element={<Redirect404 />} />
                        </Routes>
                    </Router>
                </PortalProvider>
            </div>
        );
    }
}

export default App;
